var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('IconText',{attrs:{"icon":_vm.locationIcon,"text":_vm.address,"icon-color":"red"}}),(_vm.addressAdditional)?_c('small',{staticStyle:{"margin-left":"1.8rem"}},[_vm._v(" "+_vm._s(_vm.addressAdditional)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }